// ========================
// Helpers para manejar prefijo
// ========================
function getSessionPrefix() {
    return sessionStorage.getItem("sessionPrefix");
}

function setSessionPrefix(user) {
    const prefix = `client_${user}`;
    sessionStorage.setItem("sessionPrefix", prefix);
}

// ========================
// Wrappers de localStorage con prefijo
// ========================
function setClientItem(key, value) {
    const prefix = getSessionPrefix();
    sessionStorage.setItem(`${prefix}_${key}`, value);
}

function getClientItem(key) {
    const prefix = getSessionPrefix();
    return sessionStorage.getItem(`${prefix}_${key}`);
}

function removeItem(key) {
    const prefix = getSessionPrefix();
    sessionStorage.removeItem(`${prefix}_${key}`);
}

// ========================
// Definici�n del objeto clientInformation
// ========================
const clientInformation = () => {
    clientInformation.languaje = "";
    clientInformation.Password = "";
    clientInformation.Error = false;
    clientInformation.Udf1 = "";
    clientInformation.IPAddress = "";
    clientInformation.InstanceID = 1;

    clientInformation.Name = getClientItem('Name');
    clientInformation.LastName = getClientItem('LastName');
    clientInformation.CurrencyCode = getClientItem('CurrencyCode');
    clientInformation.AvailableBalance = getClientItem('AvailableBalance');
    clientInformation.WithdrawalBalance = getClientItem('WithdrawalBalance');
    clientInformation.IPAddress = getClientItem('IPAddress');
    clientInformation.CustomerPIN = getClientItem('User');
    clientInformation.Udf1 = getClientItem('Udf1');
    clientInformation.InstanceID = getClientItem('InstanceID');

    return clientInformation;
};

// ========================
// M�todos de mapeo
// ========================
clientInformation.funcMapCustomer = async (data) => {
    console.log(data);
    setClientItem('Name', data.Authentication.Name);
    setClientItem('LastName', data.Authentication.LastName);
    setClientItem('CountryCode', data.Authentication.CountryCode);
    setClientItem('Phone', data.Authentication.Phone);
    setClientItem('SSN', data.Authentication.SSN);
};

clientInformation.funcMapBalance = async (data) => {
    setClientItem('AvailableBalance', data.Authentication.AvailableBalance);
    setClientItem('WithdrawalBalance', data.Authentication.WithdrawalBalance);
    setClientItem('CurrencyCode', data.Authentication.CurrencyCode);
};

// ========================
// Export
// ========================
export {
    setSessionPrefix,
    getSessionPrefix,
    setClientItem,
    getClientItem,
    removeItem
};

export default clientInformation;